import { useState, useEffect } from 'react'
import { Button }              from 'antd'
import classNames              from 'classnames'

import { Image, Spinner } from 'components'
import { t, copy }        from 'tools'
import config             from 'config'

import EditInfoPopup from './EditInfoPopup'

const CardContent = ({ className, loading, withShare, data, designs, name, id, working, isMine, onUpdate, onShare, canUpload, onAvatar }) => {
    const
        [ editPopup, $editPopup ] = useState( false ),
        [ editSave, $editSave ] = useState( false ),

        visibleAvatar = ( data.card_avatar ) || data.owner_user?.avatar,

        getBranded = data => {
            if ( !data || ( !data.is_branded && !data.company_owner?.company_logo_for_passbook )) { return {} }

            const
                isMobile = window.innerWidth < 768,
                source = data.company_owner?.id === config.publicEmailCompany ? data.company_design : copy.join( data.company_design, data.company_owner )

            return {
                backgroundColor: source?.company_bg_color,
                color:           source && source.company_bg_color === source.company_text_color
                    ? '#111'
                    : source?.company_text_color,
                width:       isMine ? ( isMobile ? 'calc(100vw - 32px)' : '100%' ) : '',
                flex:        isMine ? ( isMobile ? '0 0 calc(58.108vw - 32px)' : '0 0 100%' ) : '',
                height:      isMine && isMobile ? 'calc(58.108vw - 32px)' : '',
                marginRight: isMine && !isMobile ? '0' : '',
                border:      [ '#000', '#000000', 'black', 'rgb(0,0,0)' ].includes( source?.company_bg_color?.toLowerCase())
                    ? `1px solid ${source?.company_bg_color !== source?.company_custom_text_color ? source?.company_custom_text_color : '#111111'}66`
                    : (
                            source && source.company_bg_color === source.company_text_color
                                ? '1px solid #111'
                                : `1px solid ${source?.company_text_color}`
                        ),
                custom: [ '#000', '#000000', 'black', 'rgb(0,0,0)' ].includes( source?.company_bg_color?.toLowerCase())
                    ? source?.company_bg_color !== source?.company_custom_text_color ? source?.company_custom_text_color : '#111111'
                    : (
                            source && source.company_bg_color === source.company_custom_text_color
                                ? '#111'
                                : source?.company_custom_text_color
                        ),
            }
        },

        updateCard = ( data, designId ) => {
            $editPopup( false )
            $editSave( true )
            onUpdate({
                id:             data.id,
                first_name:     data.firstName,
                last_name:      data.lastName,
                position:       data.jobRole,
                company:        data.company,
                company_design: designId === 'default' ? null : designId,
                is_branded:     designId === 'default' ? false : true
            })
        }

    useEffect(() => {
        $editSave( false )
    }, [ data ])

    return (
        <>
            <main className="public-card-info">
                {
                    !withShare && (
                        <section className="public-card-hello">
                            <div className={classNames( 'public-card-avatar', ( canUpload && !visibleAvatar ) && 'with-upload', !!visibleAvatar && 'with-image' )} onClick={loading || !onAvatar ? null : () => onAvatar()}>
                                {
                                    loading
                                        ? <Spinner />
                                        : (
                                                <Image
                                                    resize = { !!data.owner_user?.avatar && visibleAvatar === data.owner_user?.avatar }
                                                    fallback = {
                                                        canUpload
                                                            ? 'data:image/svg+xml;charset=utf-8;base64,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'
                                                            : 'https://server.tabee.mobi/static/tabee/images/mails/user-image.png'
                                                    }
                                                    src = { visibleAvatar }
                                                    alt = { name }
                                                    width = "80"
                                                    height = "80"
                                                />
                                            )
                                }
                            </div>
                            <div className="public-card-phrase">
                                <h1>{t( 'publicCard.HELLO' )} { name }</h1>
                                <p>{t( 'publicCard.INTRODUCTION' )}</p>
                            </div>
                        </section>
                    )
                }
                <section className="public-card-details">
                    <div className={classNames( 'public-card-card', className )} style={getBranded( data )}>
                        <header className="pcc-header">
                            {
                                ( !data?.company_owner?.company_logo_for_passbook ) && (
                                    <h2 style={{ color: getBranded( data ).custom }}>
                                        { data.company_owner?.name || data.company }
                                    </h2>
                                )
                            }
                            {
                                ( data.company_owner?.company_logo_for_passbook ) && (
                                    <img
                                        src = { `${config.api.url}/media/${data.company_owner.company_logo_for_passbook}` }
                                        alt = { data.company_owner.name }
                                        width = "100"
                                        height = "32"
                                    />
                                )
                            }
                        </header>
                        <div className="pcc-inner">
                            <p className="pcc-name">{ name }</p>
                            <p className="pcc-title">{ data?.position }</p>
                        </div>
                        <ul className="pcc-contacts">
                            {
                                //this.shortContacts( data )
                            }
                        </ul>
                        {
                            withShare && (
                                <Button
                                    type = "primary"
                                    disabled = { working }
                                    style = {
                                        data?.company_owner?.company_logo_for_passbook
                                            ? {
                                                    backgroundColor: data.company_owner?.company_bg_color,
                                                    color:           data.company_owner && data.company_owner.company_bg_color !== data.company_owner.company_custom_text_color ? data.company_owner.company_custom_text_color : '#111',
                                                    borderTop:       `1px solid ${data.company_owner && data.company_owner.company_bg_color !== data.company_owner.company_custom_text_color ? data.company_owner.company_custom_text_color : '#111111'}66`
                                                }
                                            : {}
                                    }

                                    onClick = {onShare}
                                >
                                    {
                                        working
                                            ? (
                                                    <Spinner color={data.company_owner && data.company_owner.company_bg_color ? data.company_owner.company_bg_color : '#fff'} />
                                                )
                                            : t( 'publicCard.SHARE_CONTACTS' )
                                    }
                                </Button>
                            )
                        }
                    </div>
                    {
                        !isMine && (
                            <div className="public-card-cta-container">
                                <a href={`https://${config.api.noHttpUrl}/pb/${id}?referrer=pb_by_web`} className="public-card-cta">
                                    {t( 'publicCard.ADD_TO_WALLET_OR_TABEE' )}
                                </a>
                                <span className="public-card-cta-exp">
                                    {t( 'publicCard.DEVICE_AS' )} <a href={`https://${config.api.noHttpUrl}/card_vcf/${id}?referrer=web`}>{t( 'publicCard.VCF_CONTACT' )}</a>.
                                </span>
                            </div>
                        )
                    }
                </section>
                {
                    ( isMine && canUpload ) && (
                        <Button className="edit-card-button" onClick={() => $editPopup( true )} disabled={editSave}>
                            {
                                editSave
                                    ? <Spinner color="currentColor" />
                                    : t( 'publicCard.EDIT_CARD' )
                            }
                        </Button>
                    )
                }
            </main>
            <EditInfoPopup
                visible = { editPopup }
                data = { data }
                designs = { designs }

                onClose = { () => $editPopup( false ) }
                onSave = { updateCard }
            />
        </>
    )
}

export default CardContent
